/**
 * The policy rep fields a producer update can target — shared by the Update Policy Rep tools and the
 * AOR apply dialog so the ids (the backend contract) and labels cannot drift.
 */
export const REP_UPDATE_TYPE_OPTIONS = [
  { id: 'sales_rep', value: 'Initial Producer' },
  { id: 'bind_rep', value: 'Sold Producer' },
  { id: 'both', value: 'Both' }
];
